import React, {useEffect, 
               useState, 
               useContext}          from 'react';
import {Container, Card, Row, Col}  from 'react-bootstrap';
import api                          from './AxiosConfig';
import { BsFillCaretDownFill,
         BsFillCaretUpFill}         from "react-icons/bs";
import { SelectionContext }         from './SelectionContext';
import ChecklistSummaryItem         from './ChecklistSummaryItem';

function WeeklySummary( ) {
  const [checklists, setChecklists] = useState();
  const { getExpandedWkSummary, 
          toggleExpandedWkSummary}  = useContext(SelectionContext);
         

  useEffect(() => {
       async function getCheckListItems() {
            try {
                const response = await api.get(`/site/checklists/this-week`, {withCredentials: true });
                setChecklists(response.data);
            } catch (error) {
                console.log("getMasterGoal: " + error);
            }
        }
        getCheckListItems();
 }, []);
           
 const handleExpand = () => {
     console.log("handleExpanded");
     toggleExpandedWkSummary();
 }
         
 return (
    <Container>
      <Row className="justify-content-md-center">
        <Col>
          <Card className={'mt-2 mb-1 card-goal-type-wk-summary'}>
            <Card.Header className="card-goal-header">
              <div class="content-container">
                <div class="left-content d-flex align-items-center">
                  <span>Weekly Summary</span>
                </div>
                <div class="right-content">
                  { getExpandedWkSummary() === true ? (<BsFillCaretUpFill onClick={() => handleExpand()}/>) : (<BsFillCaretDownFill onClick={() => handleExpand()}/>) }
                </div>
              </div>
            </Card.Header>
          { checklists ? (
            <Card.Body className="p-0">
                   { checklists.map((cl, index) => (
                     <ChecklistSummaryItem key={index} clItem={cl} expanded={getExpandedWkSummary()}/>
               ))}
             </Card.Body>
              ) : ( <p>Loading...</p> ) }
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default WeeklySummary;
